export default "__VITE_ASSET__YxL3EG58__"